module.exports = __webpack_public_path__ + "static/media/Tile Image - PRIME 124-2 (1).f7846c0d.jpg";